import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { getConfig } from '../../../utils/config';

const { sendInvoiceEndpoint } = getConfig();

export const useMailSend = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();

  const sendMail = async ({
    file,
    invoiceId,
    endpoint = sendInvoiceEndpoint,
  }: {
    file: File;
    invoiceId: string;
    endpoint?: string;
  }) => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append('file', file);

      const urlParams = new URLSearchParams({ invoiceId });

      const endpointWithParams = `${endpoint}?${urlParams.toString()}`;

      const token = await getAccessTokenSilently();
      const res = await fetch(endpointWithParams, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!res.ok) {
        throw new Error(`Send mail failed (${res.status})`);
      }

      return res;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    sendMail,
    isLoading,
  };
};
